import firebase from "firebase";
import { db, auth } from "../Firebase/firebase";

export const checkCompanyFieldExist = async (field, value) => {
  let company = [];
  const result = await db
    .collection("users")
    .where(field, "==", value)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function(doc) {
        company.push({ id: doc.id, ...doc.data() });
      });
    });

  return { company, result };
};

export const checkMenuFieldExist = async (field, value) => {
  let menu = [];
  const result = await db
    .collection("menus")
    .doc(auth.currentUser.uid)
    .collection("userMenus")
    .where(field, "==", value)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function(doc) {
        menu.push({ id: doc.id, ...doc.data() });
      });
    });

  return menu;
};

export const checkCategoryFieldExists = async (field, value) => {
  let items = [];
  const result = await db
    .collection("categories")
    .doc(auth.currentUser.uid)
    .collection("userCategories")
    .where(field, "==", value)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function(doc) {
        items.push({ id: doc.id, ...doc.data() });
      });
    });
  return items;
};

export const checkItemFieldExists = async (field, value) => {
  let items = [];
  const result = await db
    .collection("Items")
    .doc(auth.currentUser.uid)
    .collection("userItems")
    .where(field, "==", value)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach(function(doc) {
        items.push({ id: doc.id, ...doc.data() });
      });
    });
  return items;
};
